import {
  change,
  Field,
  FieldArray,
  formValueSelector,
  reduxForm,
} from 'redux-form';
import {
  isInteger,
  //normalizeRate,
  normalizeDecimal,
  normalizeRate,
  renderAutoCompleteScheduling,
  renderAutoCompleteSingleSelect,
  renderCheckBox,
  renderDateField,
  renderTextField,
} from '../../../../components/reduxFields';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import Dialog from 'material-ui/Dialog';
import { getActivityServiceCodeById, GetPayerServiceCodeById, SaveServiceCodesInActivity, updatePayerAppointmentTypeCodeModifiers } from '../../actions';
import { CBF, isEmptyObject, showNormalizedRate, VIP } from '../../../../actions/utilAction';
import { CommonButton } from '../../../../components/buttons';
import validate from '../validate';
import moment from 'moment';
import _ from 'lodash';

class ActivityModal extends Component {

  constructor(props) {
    super(props);
    this.state = {
      open: true,
      cptCode: null,
      masterUnitType: props.master_data ? props.master_data.masterUnitType : [],
      masterRoundingRules: props.master_data ? props.master_data.masterRoundingRules : [],
      serviceCodeData: props.serviceCodeData,
      payerCptCodesByPayer: [],
      serviceCodeId: props.serviceCodeData ? props.serviceCodeData.ServiceCodeID : null,
      payerAppointmentTypesRestrictedActivity: [],
      payerBillingRateModel: [],
      startDate: [],
      endDate: [],
      masterNoteType: props.master_data ? props.master_data.masterNoteType : [],
    };
    this.onDateChange = this.onDateChange.bind(this);
  }

  handleClose = () => {
    this.setState({ open: false });
    this.props.closeDialog();
  };

  componentWillMount() {
    if (this.props.payerActivityServiceCodeId) {
      this.props.getActivityServiceCodeById(this.props.payerActivityServiceCodeId, null);
    }
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.masterPayerCptCodes) {
      let a = [];
      nextProps.payerCptCodesByPayer.data.filter((data) => {
        if (nextProps.masterPayerCptCodes.data.find((obj) => obj.serviceCodeID !== data.serviceCodeID)) {
          let x = {
            id: data.payerServiceCodeID,
            value: data.cptCode,
          };
          a.push(x);
        }
        return a;
      });
      this.setState({ payerCptCodesByPayer: a });
    }

    if (nextProps.payerServiceCodeDetailsData && nextProps.payerServiceCodeDetailsData !== this.props.payerServiceCodeDetailsData) {
      let aptTypeData = nextProps.payerServiceCodeDetailsData.data;      
      let payerAppointmentTypesRestrictedActivity = aptTypeData.payerAppointmentTypesRestrictedActivity || [];      
      this.setState({ payerAppointmentTypesRestrictedActivity: payerAppointmentTypesRestrictedActivity});
    }

    if (nextProps.payerServiceCodeDetailsData && nextProps.payerServiceCodeDetailsData.data && nextProps.payerServiceCodeDetailsData != this.props.payerServiceCodeDetailsData) {      
      let startDate = this.state.startDate;
      let endDate = this.state.endDate;
      (nextProps.payerServiceCodeDetailsData.data.payerBillingRateModel || []).forEach((obj, index) => {          
          if(obj.startDate != undefined)
          {
            _.update(startDate, `[${index}]`, function (n) {
                return moment(obj.startDate).format('MM-DD-YYYY');
            });
          
            this.props.dispatch(change('ActivityModal', `payerBillingRateModel[${index}].startDate`, moment(obj.startDate).format('MM-DD-YYYY') || null));
          }

          if(obj.endDate != undefined)
          {
            _.update(endDate, `[${index}]`, function (n) {
                return moment(obj.endDate).format('MM-DD-YYYY');
            });            

            this.props.dispatch(change('ActivityModal', `payerBillingRateModel[${index}].endDate`, moment(obj.endDate).format('MM-DD-YYYY') || null));
          }

          this.props.dispatch(change('ActivityModal', `payerBillingRateModel[${index}].id`, obj.id || 0));
        
          this.props.dispatch(change('ActivityModal', `payerBillingRateModel[${index}].payerAppointmentTypeId`,obj.payerAppointmentTypeId || 0));
        
          //this.props.dispatch(change('ActivityModal', `payerBillingRateModel[${index}].rate`,showNormalizedRate(obj.rate)|| 0.00));        
          
      });

      this.setState({ startDate: startDate, endDate: endDate });
   
    }
  }

  handleNewRequest = (input, selectedRecord) => {
    if (input.name === 'payerServiceCodeID') {
      input.onChange(selectedRecord.value);
      this.setState({ cptCode: selectedRecord.label });
      if (selectedRecord.value) {
        // let apptId = null,
        let serviceCodeId = selectedRecord.value;
        this.props.GetPayerServiceCodeById(serviceCodeId);
      }
      // let propsData = this.props.payerCptCodesByPayer.data.slice(0);

      // propsData.filter((data) => {
      //   if ((data.payerServiceCodeID === selectedRecord.value)) {
      //     cptDetail = data;
      //   }
      //   return cptDetail;
      // });
      // if (cptDetail) {
      //   this.props.dispatch(change('ActivityModal', 'description', cptDetail.description));
      //   this.props.dispatch(change('ActivityModal', 'unitDuration', cptDetail.unitDuration));
      //   this.props.dispatch(change('ActivityModal', 'unitTypeID', cptDetail.unitTypeID));
      //   this.props.dispatch(change('ActivityModal', 'ratePerUnit', showNormalizedRate(cptDetail.ratePerUnit)));
      //   this.props.dispatch(change('ActivityModal', 'isBillable', cptDetail.isBillable));
      // } else {
      //   this.props.dispatch(change('ActivityModal', 'description', null));
      //   this.props.dispatch(change('ActivityModal', 'unitDuration', null));
      //   this.props.dispatch(change('ActivityModal', 'unitTypeID', null));
      //   this.props.dispatch(change('ActivityModal', 'ratePerUnit', null));
      //   this.props.dispatch(change('ActivityModal', 'isBillable', null));
      // }
    }

    if (input.name === 'unitTypeID' || input.name === 'noteTypeId') {
      input.onChange(selectedRecord.value);
    } else if (input.name === 'Modifier1' || input.name === 'Modifier2' || input.name === 'Modifier3' || input.name === 'Modifier4') {
      input.onChange(selectedRecord.value);
    } else {
      input.onChange(selectedRecord.id);
    }
  };

  onSubmitHandler(formData) {
    let payerAppointmentTypesRestrictedActivity = [];
    if (formData.restrictedActivities) {
      payerAppointmentTypesRestrictedActivity = (this.state.payerAppointmentTypesRestrictedActivity || []).map((Obj) => {
        return { ...Obj, isDeleted: true };
      });

      (formData.restrictedActivities || []).forEach((appointmentTypeId) => {
        // update case for restrictedActivities ------
       //console.log('payerAppointmentTypesRestrictedActivity12........',payerAppointmentTypesRestrictedActivity);

        let restrictedActivities = payerAppointmentTypesRestrictedActivity.find((Obj) => Obj.appointmentTypeId === appointmentTypeId && Obj.isDeleted);
        if (restrictedActivities) {
          let index = payerAppointmentTypesRestrictedActivity.indexOf(restrictedActivities);
          payerAppointmentTypesRestrictedActivity[index] = {
            ...restrictedActivities,
            'isDeleted': false,
          };
        } else {
          payerAppointmentTypesRestrictedActivity.push({
            'id': 0,
            'payerAppointmentTypeId': this.props.payerActivityServiceCodeId || 0,
            'appointmentTypeId': appointmentTypeId,
            'isDeleted': false,
          });
        }
      });
   
      payerAppointmentTypesRestrictedActivity = payerAppointmentTypesRestrictedActivity.filter((obj) => obj.isDeleted === false);
    }

    // ---------------Start Save to payerBillingRateModel in payer service code------------

    let listRateModel = [];
    if (formData.payerBillingRateModel && formData.payerBillingRateModel.length > 0 && !isEmptyObject(formData.payerBillingRateModel[0])) { //  Save Tags
      formData.payerBillingRateModel.filter((data, i) => {
        if (data.rate) {          
          let currentRate = {
            'id': this.props.initialValues && this.props.initialValues.payerAppointmentTypeId === 0 ? 0 : data.id ? data.id : 0,
            'payerAppointmentTypeId': this.props.initialValues && this.props.initialValues.payerAppointmentTypeId === 0 ? 0 : this.props.initialValues.payerAppointmentTypeId,
            'startDate':  data.startDate ? moment(data.startDate).format('YYYY-MM-DD') + 'T' + moment(data.startDate).format('HH:mm:ss') : null,
            'endDate':  data.endDate ? moment(data.endDate).format('YYYY-MM-DD') + 'T' + moment(data.endDate).format('HH:mm:ss') : null,
            'rate': data.rate ? showNormalizedRate(data.rate) : 0,            

          };

          listRateModel.push(currentRate);
        }
        return listRateModel;
      });
    }
    formData.payerBillingRateModel = listRateModel;
    // ---------------End Save to payerBillingRateModel in payer service code------------

    if (this.props.payerServiceCodeId) {
      let formProps = {
        'Id': this.props.payerActivityServiceCodeId,
        'RatePerUnit': formData.ratePerUnit ? formData.ratePerUnit : null,
        'Modifier1': formData.Modifier1 ? formData.Modifier1 : null,
        'Modifier2': formData.Modifier2 ? formData.Modifier2 : null,
        'Modifier3': formData.Modifier3 ? formData.Modifier3 : null,
        'Modifier4': formData.Modifier4 ? formData.Modifier4 : null,
        'payerActivityNPINumber': formData.payerActivityNPINumber || null,
        'secondaryLicense': formData.secondaryLicense || 0,
        'payerAppointmentTypesRestrictedActivity': payerAppointmentTypesRestrictedActivity,
        'payerBillingRateModel': formData.payerBillingRateModel,
        'noteTypeId': formData.noteTypeId,     
      };
      this.props.updatePayerAppointmentTypeCodeModifiers(formProps);
      this.handleClose();
      return false;
    }
    let postData = {
      'id': 0,
      'appointmentTypeID': this.props.selectedActivityId,
      'payerID': this.props.payerId,
      'payerServiceCodeID': formData.payerServiceCodeID,
      'modifier1': formData.Modifier1 ? formData.Modifier1 : null,
      'modifier2': formData.Modifier2 ? formData.Modifier2 : null,
      'modifier3': formData.Modifier3 ? formData.Modifier3 : null,
      'modifier4': formData.Modifier4 ? formData.Modifier4 : null,
      'ratePerUnit': formData.ratePerUnit,
      'payerActivityNPINumber': formData.payerActivityNPINumber || null,
      'secondaryLicense': formData.secondaryLicense || 0,
      'payerAppointmentTypesRestrictedActivity': payerAppointmentTypesRestrictedActivity,
      'payerBillingRateModel': formData.payerBillingRateModel,
      'noteTypeId': formData.noteTypeId,      
    };

    // console.log('postData..............', postData)
    this.props.SaveServiceCodesInActivity(postData);
    this.handleClose();
  }

  checkIsSameOrBefore = (date1, date2) => {
    return moment(date1).isSameOrBefore(date2);  
  }
  // clearValue = (e) => {
  //   let name = e.target.name;
  //   let value = e.target.value;

  //   let modifierArr = ['Modifier1', 'Modifier2', 'Modifier3', 'Modifier4'];
  //   if (_.includes(modifierArr, name) && value === '') {
  //     if (name === 'Modifier1') {
  //       this.props.dispatch(change('ActivityModal', 'Modifier2', null));
  //       this.props.dispatch(change('ActivityModal', 'Modifier3', null));
  //       this.props.dispatch(change('ActivityModal', 'Modifier4', null));
  //     } else if (name === 'Modifier2') {
  //       this.props.dispatch(change('ActivityModal', 'Modifier3', null));
  //       this.props.dispatch(change('ActivityModal', 'Modifier4', null));
  //     } else if (name === 'Modifier3') {
  //       this.props.dispatch(change('ActivityModal', 'Modifier4', null));
  //     }
  //   }
  // }

  handleNewMultiRequest(input, value) {
    input.onChange(value);    
  }  

  checkIsBefore = (date1, date2) => {
    return moment(date1).isBefore(date2);  
  }
  
  onDateChange = (input, value, i, type) => {
      input.onChange(moment(value).format());
      if(type === 'FROM DATE')
      {
          let startDate = this.state.startDate;
  
          _.update(startDate, `[${i}]`, function (n) {
            return moment(value).format('YYYY-MM-DD') + 'T' + moment(value).format('HH:mm:ss');
          });
  
          this.setState({ startDate: startDate }, ()=>{                  
            document.getElementsByName(`payerBillingRateModel[${i}].endDate`)[0].focus();  
        });
  
        let selectorPayerBillingRate = this.props.selectorPayerBillingRate || [];
        let selectedDateIndex  = i;//this.state.startDate.length - 1;      
        
        this.props.dispatch(change('ActivityModal', `payerBillingRateModel[${i}].startDate`,moment(value).format('MM-DD-YYYY') || null));

        if(selectedDateIndex > 0) {

          let endDate = this.state.endDate;              
          let endDateOfLastSameActivity  = moment(this.state.startDate[selectedDateIndex]).subtract(1, "days");
          let lastIndexOfEndDate = 0;

          selectorPayerBillingRate.forEach((obj, index) => {        
            if(lastIndexOfEndDate !== null && index != selectedDateIndex && index <= selectedDateIndex)
            {      
              lastIndexOfEndDate = index;
            }
          });

          endDate[lastIndexOfEndDate] = this.state.startDate[lastIndexOfEndDate]  != null && endDateOfLastSameActivity > this.state.startDate[lastIndexOfEndDate]  ? this.state.startDate[lastIndexOfEndDate] : endDateOfLastSameActivity;      
        
          if(lastIndexOfEndDate >= this.props.selectorPayerBillingRate.length -1)
          {
            lastIndexOfEndDate = lastIndexOfEndDate - 1;
          }
          if(moment(endDate[lastIndexOfEndDate]).format('MM-DD-YYYY') !== 'Invalid date' && this.checkIsSameOrBefore(moment(endDate[lastIndexOfEndDate]).format('MM-DD-YYYY'), moment(startDate[lastIndexOfEndDate]).format('MM-DD-YYYY'))) {        
            endDate[lastIndexOfEndDate] = moment(startDate[lastIndexOfEndDate]).format('MM-DD-YYYY');
          }
          this.setState({endDate: endDate},()=>{                 
            this.props.dispatch(change('ActivityModal', `payerBillingRateModel[${lastIndexOfEndDate}].endDate`,moment(endDate[lastIndexOfEndDate]).format('MM-DD-YYYY') || null));
          });
        }
      }
      else if(type === 'TO DATE')
      {
          let endDate = this.state.endDate;
  
          _.update(endDate, `[${i}]`, function (n) {
            return moment(value).format('YYYY-MM-DD') + 'T' + moment(value).format('HH:mm:ss');
          });
          
          this.setState({ endDate: endDate }, ()=>{                  
            document.getElementsByName(`payerBillingRateModel[${i}].startDate`)[0].focus();           
        });
      }
    }

    addOneDay = (date) => {    
      date.setDate(date.getDate() + 1);
      return date;
    }
  
  addRateRow = () => { };
  removeRateRow = (i) => { };
  // removeRateRowFromDatabase = (i, rateId) => { };

  renderBillingRateTemplate = ({ fields }) => {
    // this.addRateRow = (e) => {
    //   fields.push({});
    // };

    // this.removeRateRow = (i, e) => {
    //   fields.remove(i);
    // };

    
    this.removeRateRow = (index) => {
      let startDate = this.state.startDate;  
     let startDateWithIndex = this.state.startDate[index];
      for(let j = 0; j < this.state.startDate.length; j++)
      {
          if(startDate[j] === undefined)
          {
            startDate[j] = null;
          }
      }
      fields.remove(index);
      let selectedEndDateValue = this.state.endDate[index];
      this.setState({
        startDate: startDate.filter((_, i) => i !== index),
        endDate: this.state.endDate.filter((_, i) => i !== index)
      },() => {
        if(startDateWithIndex != undefined) {
          let endDate = this.state.endDate;
          let startDate = this.state.startDate;        
          let selectorPayerBillingRate = this.props.selectorPayerBillingRate.filter((_, i) => i !== index) || [];
          let selectedDateIndex  = index;//,indexCount1 = 0;
          let endDateOfPreviousRange  = moment(this.state.startDate[selectedDateIndex]).subtract(1, "days");       
          selectorPayerBillingRate.forEach((obj, i) => {   
              let selectedDateIndex  = index - 1;  
              if(selectedDateIndex < 0)
                selectedDateIndex = 0;
                let lastIndexOfEndDate = 0, indexCount = 0;
                  let endDatePrevious = this.state.startDate[i] > endDateOfPreviousRange ? this.state.startDate[i] : endDateOfPreviousRange;
                    selectedDateIndex  = index;//this.state.startDate.length - 1; '
                    let therapyPreviousIndex = 0, therapyNextIndex = 0, flag = true;                     
                    let selectorPayerBillingRate = this.props.selectorPayerBillingRate || [];                  
                    selectorPayerBillingRate.forEach((obj, i) => {        
                            
                          if(i < selectedDateIndex)   
                            therapyPreviousIndex = i;
                          else if(i >= selectedDateIndex && flag) {
                            therapyNextIndex = i;
                            flag = false;
                          }  
                          indexCount = indexCount + 1;
                            
                          if(i != selectedDateIndex)
                          {      
                            lastIndexOfEndDate = i;
                          }
                        });

                        if(indexCount > 1 && indexCount >= this.props.selectorPayerBillingRate.length ) {
                          if(therapyPreviousIndex >= 0){
                                if(therapyNextIndex === 0) {
                                  endDate[therapyPreviousIndex] = null;
                                }
                                else {
                                  endDate[therapyPreviousIndex] = moment(startDate[therapyNextIndex]).subtract(1, "days");
                                }
                              this.props.dispatch(change('ActivityModal', `payerBillingRateModel[${therapyPreviousIndex}].endDate`, endDate[therapyPreviousIndex]));
                          }
                          else if(selectedDateIndex === lastIndexOfEndDate || (indexCount + 1) === lastIndexOfEndDate || (selectedDateIndex - 1) === lastIndexOfEndDate){
                            endDate[lastIndexOfEndDate] = null;
                            this.props.dispatch(change('ActivityModal', `payerBillingRateModel[${lastIndexOfEndDate}].endDate`, null));
                          }
                          else if(lastIndexOfEndDate < indexCount) {                                
                            endDate[lastIndexOfEndDate] = moment(startDate[selectedDateIndex]).subtract(1, "days");
                          }   
                          else if(startDate[selectedDateIndex - 1] != null && this.checkIsSameOrBefore(moment(endDatePrevious).format('MM-DD-YYYY'), moment(startDate[selectedDateIndex - 1]).format('MM-DD-YYYY'))) {    
                            endDate[selectedDateIndex - 1] = startDate[selectedDateIndex - 1];
                          }                           
                          else {
                            if(endDatePrevious  != undefined && moment(endDatePrevious).format('MM-DD-YYYY') !== 'Invalid date'){
                              endDate[selectedDateIndex - 1] = endDatePrevious;
                            }
                            else {
                              endDate[selectedDateIndex - 1] =  selectedEndDateValue;
                            }
                          }
                          this.props.dispatch(change('ActivityModal', `payerBillingRateModel[${selectedDateIndex - 1}].endDate`, endDate[selectedDateIndex - 1]));
                        } else if(indexCount > 1 && indexCount < this.props.selectorPayerBillingRate.length ){
                          endDate[selectedDateIndex - 1] = null;
                          this.props.dispatch(change('ActivityModal', `payerBillingRateModel[${selectedDateIndex - 1}].endDate`, null));
                        } else {
                          endDate[lastIndexOfEndDate] = null;
                          this.props.dispatch(change('ActivityModal', `payerBillingRateModel[${lastIndexOfEndDate}].endDate`, null));
                        }

                  this.setState({endDate: endDate},()=>{
                    document.getElementsByName(`payerBillingRateModel[${i}].startDate`)[0].focus(); 
                  });
          });
        }
      });
    };

    this.addRateRow = (e) => {
      fields.push({});
    };

    let startDate = this.state.startDate;
    let endDate = this.state.endDate;

    return (
      <div>
        {fields.map((payerBillingRateModel, i) =>{
          if(this.state.startDate[i] === undefined)
          {   
            _.update(startDate, `[${i}]`, function (n) {
              return null;
            });          
            this.setState({ startDate: startDate });
          }   
          if(this.state.endDate[i] === undefined)
          {   
            _.update(endDate, `[${i}]`, function (n) {
              return null;
            });          

            this.setState({ endDate: endDate });
          }              
        return (
          <div id="currentDiv" className="row" key={i}>
            <div className="col-sm-3">
                <Field
                    name={`payerBillingRateModel[${i}].startDate`}
                    placeholder="From Date"
                    locale="en-US"
                    minDate={(this.state.startDate[i - 1] !== undefined && this.state.startDate[i - 1] !== null ? (this.addOneDay(new Date(this.state.startDate[i - 1]))) : (this.state.endDate[i - 1] !== undefined && this.state.endDate[i - 1] !== null ? (this.addOneDay(new Date(this.state.endDate[i - 1]))) : new Date(1900, 9, 11)))}
                    //minDate={this.props.selectorPayerBillingRate && this.props.selectorPayerBillingRate.filter((_, index) => index === (i - 1)) && this.props.selectorPayerBillingRate.filter((_, index) => index === (i - 1))[0] && this.props.selectorPayerBillingRate.filter((_, index) => index === (i - 1))[0].startDate !== undefined && this.props.selectorPayerBillingRate.filter((_, index) => index === (i - 1))[0].startDate !== null   ?  (this.state.lastIndexOfEndDate !== null && this.props.selectorPayerBillingRate && this.props.selectorPayerBillingRate.filter((_, index) => index === this.state.lastIndexOfEndDate)[0] && this.props.selectorPayerBillingRate.filter((_, index) => index === this.state.lastIndexOfEndDate)[0].startDate != null  ? (this.addOneDay(new Date(this.props.selectorPayerBillingRate.filter((_, index) => index === this.state.lastIndexOfEndDate)[0].startDate))) : (this.state.lastIndexOfEndDate !== null && this.props.selectorPayerBillingRate && this.props.selectorPayerBillingRate.filter((_, index) => index === this.state.lastIndexOfEndDate)[0] && this.props.selectorPayerBillingRate.filter((_, index) => index === this.state.lastIndexOfEndDate)[0].endDate != null  ? (this.addOneDay(new Date(this.props.selectorPayerBillingRate.filter((_, index) => index === this.state.lastIndexOfEndDate)[0].endDate))) : new Date(1900, 9, 11))) : new Date(1900, 9, 11)}
                    maxDate={this.state.endDate[i] ? this.state.endDate[i] : new Date(2120, 9, 11)}                    
                    //minDate={this.state.startDate[i-1] || new Date(2120, 9, 11)}
                    selected={this.state.startDate[i] || null}
                    onDateChange={(input, value) => this.onDateChange(input, value, i, 'FROM DATE')}
                    openToYearSelection={true}
                    component={renderDateField} />
            </div>
            <div className="col-sm-3">
              <Field
                name={`payerBillingRateModel[${i}].endDate`}
                placeholder="To Date"
                locale="en-US"
                minDate={this.state.startDate[i] || null}
                selected={this.state.endDate[i] || null}
                onDateChange={(input, value) => this.onDateChange(input, value, i, 'TO DATE')}
                openToYearSelection={true}
                disabled={true}
                component={renderDateField} />
            </div>
            <div className="col-sm-3 require">                
                <Field
                     name={`payerBillingRateModel[${i}].rate`}
                    type="text"
                    // disabled={true}
                    maxLength="8"
                    label="Rate Per Unit ($)"
                    component={renderTextField}
                    normalize={normalizeDecimal}
                  />
            </div>           
            <div className="col-sm-3">
              {fields.length === i + 1 ?
                <div>
                  {fields.length > 1 ?
                    <button className="additem removeitem"
                      onClick={this.removeRateRow.bind(this, i)}
                      title="Remove Rate"
                      type="button">
                      <b className="fa fa-minus-square redfont" aria-hidden="true"></b>
                    </button>
                  : ''}
                  <button className="additem" title="Add Rate" onClick={(e) => this.addRateRow()} type="button">
                    <b className="fa fa-plus-square greenfont" aria-hidden="true"></b>
                  </button>
                </div>
                :
                <div>
                  
                    <button className="additem"
                      onClick={this.removeRateRow.bind(this, i)}
                      title="Remove Rate"
                      type="button">
                      <b className="fa fa-minus-square redfont" aria-hidden="true"></b>
                    </button>
                  
                </div>
              }
            </div>
          </div>
          );
        })
      }
      </div>
    );
  };


  render() {
    const { handleSubmit, payerServiceCodeId } = this.props;
    const actions = [
      <CommonButton className="grey_btn mr-15" label="Cancel" onTouchTap={this.handleClose} />,
      <CommonButton primary={true} className="mr-15" label="Save" onTouchTap={handleSubmit(this.onSubmitHandler.bind(this))} />,

    ];
    return (
      <Dialog className="custom_modal"
        title={payerServiceCodeId ? 'Edit Service Code' : 'Add Service Code'}
        modal={false}
        actions={actions}
        open={this.state.open}
        autoScrollBodyContent={true}>

        <div className="row">
          <div className="col-sm-12">
            <form className="readmin-form custom_form" onSubmit={handleSubmit(this.onSubmitHandler.bind(this))}>
              <div className="row">
                {payerServiceCodeId ?
                  (<div className="col-sm-6 require">
                    <Field
                      name="serviceCodeName"
                      label="Service Code"
                      disabled={true}
                      component={renderTextField} />
                  </div>)
                  : (
                    <div className="col-sm-6 mt-35">
                      <Field
                        name="payerServiceCodeID"
                        label="Service Code"
                        handleNewRequest={this.handleNewRequest}
                        options={this.props.excludedCptCodes}
                        component={renderAutoCompleteSingleSelect}
                      />
                    </div>)}
                {/* {(this.props.agencyName.toUpperCase().startsWith(EBS) || this.props.agencyName.toUpperCase() === SWANCONSULTINGINC || this.props.agencyName.toUpperCase() === DEMO || this.props.agencyName.toUpperCase() === BUILDABLOCKTHERAPY || this.props.agencyName.toUpperCase() === EARLYBIRDSABA || this.props.agencyName.toUpperCase() === CBG || this.props.agencyName.toUpperCase() === BRIDGES || this.props.agencyName.toUpperCase() === PACE || this.props.agencyName.toUpperCase() === ALLIUM || this.props.agencyName.toUpperCase() === GOLDENFLOWERNW || this.props.agencyName.toUpperCase() === SEEDLINGSABA || this.props.agencyName.toUpperCase() === BLUEBIRDBEHAVIORAL || this.props.agencyName.toUpperCase() === STAR || this.props.agencyName.toUpperCase() === AMEGO || this.props.agencyName.toUpperCase() === UPSTATEABA || this.props.agencyName.toUpperCase() === CAMINOABA) ? */}
                  <div className="col-sm-6">
                    <Field
                      name="payerActivityNPINumber"
                      label="Personal NPI Number (For SCA)"
                      maxLength='10'
                      component={renderTextField}
                      normalize={isInteger}
                    />
                  </div>
                  {/* : null} */}
              </div>
              <div className="row">
                <div className="col-sm-12">
                  <Field
                    name="description"
                    type="text"
                    disabled={true}
                    maxLength="1000"
                    label="Description"
                    multiLine={true}
                    rowsMax={6}
                    fullWidth={true}
                    component={renderTextField} />
                  <small className="blackfont font12">{this.props.description ? 1000 - this.props.description.length : 1000} Characters remaining </small>
                </div>
              </div>
              <div className="row">
                <div className="col-sm-12 col-md-6 require">
                  <Field
                    name="unitDuration"
                    type="text"
                    disabled={true}
                    maxLength="3"
                    label="Unit Duration"
                    component={renderTextField}
                    normalize={isInteger}
                  />
                </div>
                <div className="col-sm-12 col-md-6 require mt-35" >
                  <Field
                    name="unitTypeID"
                    disabled={true}
                    label="Unit Type"
                    handleNewRequest={this.handleNewRequest}
                    options={this.state.masterUnitType}
                    component={renderAutoCompleteSingleSelect}
                  />
                </div>
              </div>
              <div className="row">
                <div className="col-sm-12 col-md-6">
                  <Field
                    name="ratePerUnit"
                    type="text"
                    // disabled={true}
                    maxLength="8"
                    label="Rate Per Unit ($)"
                    component={renderTextField}
                    normalize={normalizeDecimal}
                  />
                </div>
                <div className="col-sm-12 col-md-6">
                  <Field className="mt38 mb0"
                    name="isBillable"
                    label="Billable"
                    disabled={true}
                    component={renderCheckBox}
                  />
                </div>
                {/* <div className="col-sm-12 col-md-6">
                  <Field className="mt20 mb0"
                    name="isActive"
                    label="Active"
                    component={renderCheckBox}
                  />
                </div>*/}
              </div>
              <div className="row">
                <div className="col-sm-12 col-md-6 mt-35">
                  <Field
                    name="Modifier1"
                    label="Modifier 1"
                    handleNewRequest={this.handleNewRequest}
                    options={this.props.modifierList}
                    component={renderAutoCompleteSingleSelect}
                  />
                </div>
                <div className="col-sm-12 col-md-6 mt-35">
                  <Field
                    name="Modifier2"
                    label="Modifier 2"
                    handleNewRequest={this.handleNewRequest}
                    disabled={this.props.Modifier1 ? false : true}
                    options={this.props.modifierList}
                    component={renderAutoCompleteSingleSelect}
                  />
                </div>
              </div>
              <div className="row">
                <div className="col-sm-12 col-md-6 mt-35">
                  <Field
                    name="Modifier3"
                    label="Modifier 3"
                    handleNewRequest={this.handleNewRequest}
                    disabled={this.props.Modifier2 ? false : true}
                    options={this.props.modifierList}
                    component={renderAutoCompleteSingleSelect}
                  />
                </div>
                <div className="col-sm-12 col-md-6 mt-35">
                  <Field
                    name="Modifier4"
                    label="Modifier 4"
                    handleNewRequest={this.handleNewRequest}
                    disabled={this.props.Modifier3 ? false : true}
                    options={this.props.modifierList}
                    component={renderAutoCompleteSingleSelect}
                  />
                </div>
              </div>
              {(this.props.agencyName.toUpperCase() === VIP || this.props.agencyName.toUpperCase() === CBF) ? 
              <div className="row">
                <div className="col-sm-12 col-md-6">
                  <Field className="mt38 mb0"
                    name="secondaryLicense"
                    label="Secondary License"                    
                    component={renderCheckBox}
                  />
                </div>
                <div className="col-sm-12 col-md-6"></div>
              </div>
              :null}
              <div className='row'>
                <div className="col-sm-6 mt-40">
                  <small className="greyfont font12">Disable overlap with following activities: </small>
                  <Field
                    name="restrictedActivities"
                    label="Disabled Activities"
                    handleNewRequest={this.handleNewMultiRequest}
                    options={this.props.masterAppointmentTypes}
                    component={renderAutoCompleteScheduling}
                    fullWidth={true}
                  />
                  {/* <small className="redfont font12">Leave this blank if you would like all staff to have access to this appointment type </small> */}
                </div>
                <div className="col-sm-6 mt-50">
                  <Field
                    name="noteTypeId"                  
                    label="Select Session Note"
                    disabled={this.props.editSessionNoteTypePermission ? false : true}
                    handleNewRequest={this.handleNewRequest}
                    options={this.state.masterNoteType}
                    component={renderAutoCompleteSingleSelect}
                  />
                  <small className="redfont font12">Editing this session note type will override master session note type.</small>
                </div>
              </div>
              
              <FieldArray name="payerBillingRateModel" component={this.renderBillingRateTemplate} />

            </form>
          </div>
        </div>
      </Dialog>
    );
  }
}

const selector = formValueSelector('ActivityModal');

function mapStateToProps(state, ownProps) {
  let initialData = {
    payerBillingRateModel: [{}],
    noteTypeId: ownProps.noteTypeId ? ownProps.noteTypeId : null,
  };
  let modifierList = null;
  let selectorServiceCodeId = selector(state, 'payerServiceCodeID');
  if ((selectorServiceCodeId || ownProps.payerServiceCodeId) && state.payer.payerServiceCodeDetailsData && state.payer.payerServiceCodeDetailsData.data) {
    let serviceCodeObj = state.payer.payerServiceCodeDetailsData.data;
    // console.log('state.payer.payerServiceCodeDetailsData.data', state.payer.activityServiceCodeById);
    let payerAppointmentTypesRestrictedActivity = (serviceCodeObj.payerAppointmentTypesRestrictedActivity || []).map((obj) => obj.appointmentTypeId);
    initialData = {
      serviceCodeName: ownProps.payerServiceCodeId ? ownProps.payerServiceCodeName : null,
      payerServiceCodeID: serviceCodeObj.id,
      payerAppointmentTypeId: serviceCodeObj.payerAppointmentTypeId,
      description: serviceCodeObj.description,
      unitDuration: serviceCodeObj.unitDuration,
      unitTypeID: serviceCodeObj.unitType,
      noteTypeId: serviceCodeObj.noteTypeId ? serviceCodeObj.noteTypeId : ownProps.noteTypeId ? ownProps.noteTypeId : null,
      isBillable: serviceCodeObj.isBillable,
      Modifier1: serviceCodeObj.modifier1 ? serviceCodeObj.modifier1 : null,
      Modifier2: serviceCodeObj.modifier2 ? serviceCodeObj.modifier2 : null,
      Modifier3: serviceCodeObj.modifier3 ? serviceCodeObj.modifier3 : null,
      Modifier4: serviceCodeObj.modifier4 ? serviceCodeObj.modifier4 : null,
      ratePerUnit: showNormalizedRate(serviceCodeObj.ratePerUnit || 0),
      payerActivityNPINumber: serviceCodeObj.payerActivityNPINumber,
      secondaryLicense: serviceCodeObj.secondaryLicense,
      restrictedActivities: payerAppointmentTypesRestrictedActivity,    
      payerAppointmentTypesRestrictedActivity: serviceCodeObj.payerAppointmentTypesRestrictedActivity 
    };
    let modifiers = [];
    if (state.payer.payerServiceCodeDetailsData.data.payerModifierModel.length > 0) {
      state.payer.payerServiceCodeDetailsData.data.payerModifierModel.filter((data, i) => {
        if (data.payerServiceCodeId > 0) {
          modifiers.push({
            'id': data.id,
            'value': data.value,
          });
        }
        return modifiers;
      });
    }
    modifierList = modifiers;

    let payerBillingRateModel = [];

    if (state.payer.payerServiceCodeDetailsData && state.payer.payerServiceCodeDetailsData.data && state.payer.payerServiceCodeDetailsData.data.payerBillingRateModel && state.payer.payerServiceCodeDetailsData.data.payerBillingRateModel.length > 0) {
  
      state.payer.payerServiceCodeDetailsData.data.payerBillingRateModel.filter((data, i) => {
      
        payerBillingRateModel.push({
            'id': data.id ? data.id : 0,
            'payerAppointmentTypeId': data.payerAppointmentTypeId,          
            'startDate': data.startDate,
            'endDate': data.endDate,
            'rate': data.rate && showNormalizedRate(data.rate),           
          });
        
        return payerBillingRateModel;
      });
      initialData['payerBillingRateModel'] = payerBillingRateModel && payerBillingRateModel.length > 0 ? payerBillingRateModel : [{}];
    } else {
      initialData['payerBillingRateModel'] = [{}];
    }
  }

  // Start For Role Permission
  let userActionPermission = [];
  if (state.login.userPermission) {
    let userModulePermission = state.login.userPermission.modulePermissions.filter((obj) => obj.moduleKey === 'PAYER');
    let userScreenPermission = state.login.userPermission.screenPermissions.filter((obj) => obj.screenKey === 'PAYER_ACTIVITY' && obj.moduleId === userModulePermission[0].moduleId);
    userActionPermission = state.login.userPermission.actionPermissions.filter((obj) => obj.screenId === userScreenPermission[0].screenId && obj.moduleId === userModulePermission[0].moduleId && obj.roleId === state.login.loginUserInfo.roleID);
  }

  let hasDefaultAccess = state.login.loginUserInfo && state.login.loginUserInfo.users3.userRoles.userType === 'ADMIN' ? true : false; // For Role Permission

  let editSessionNoteTypePermission = hasDefaultAccess ? true : userActionPermission && userActionPermission.filter((obj) => obj.actionKey === 'PAYER_ACTIVITY_EDIT_SESSION_NOTE_TYPE')[0] ? userActionPermission.filter((obj) => obj.actionKey === 'PAYER_ACTIVITY_EDIT_SESSION_NOTE_TYPE')[0].permission : false;

  // End For Role Permission
  return {
    master_data: state.payer.master_data,
    initialValues: initialData,
    masterPayerCptCodes: state.payer.masterPayerCptCodes,
    payerCptCodesByPayer: state.payer.payerCptCodesByPayer,
    activePayerId: state.payer.activePayerId,
    payerCptCodesByActivity: state.payer.payerCptCodesByActivity,
    unitTypeID: selector(state, 'unitTypeID'),
    ratePerUnit: selector(state, 'ratePerUnit'),
    unitDuration: selector(state, 'unitDuration'),
    description: selector(state, 'description'),
    isBillable: selector(state, 'isBillable'),
    Modifier1: selector(state, 'Modifier1'),
    Modifier2: selector(state, 'Modifier2'),
    Modifier3: selector(state, 'Modifier3'),
    payerActivityNPINumber: selector(state, 'payerActivityNPINumber'),
    secondaryLicense: selector(state, 'secondaryLicense'),
    restrictedActivities: selector(state, 'restrictedActivities'),
    selectorPayerBillingRate: selector(state, 'payerBillingRateModel'),
    noteTypeId: selector(state, 'noteTypeId'),
    modifierList: modifierList,
    agencyName: state.login.organizationDetails && state.login.organizationDetails.businessName ? state.login.organizationDetails.businessName : '',
    masterAppointmentTypes: state.payer.master_data.appointmentType,
    payerServiceCodeDetailsData: state.payer.payerServiceCodeDetailsData,
    editSessionNoteTypePermission: editSessionNoteTypePermission,
  };
}


ActivityModal = reduxForm({
  form: 'ActivityModal',
  validate,
  enableReinitialize: true,
})(ActivityModal);

export default connect(mapStateToProps, { getActivityServiceCodeById, SaveServiceCodesInActivity, GetPayerServiceCodeById, updatePayerAppointmentTypeCodeModifiers })(ActivityModal);



// WEBPACK FOOTER //
// ./src/modules/Payers/containers/payerModule/activityServiceCodeModal.js